import { useApolloClient } from '@apollo/client/react';
import { useTranslations } from '@vocab/react';
import { ButtonIcon, IconDownload } from 'braid-design-system';

import { Page, useTrackingClient } from 'src/context/tracking';
import {
  attachUnsavedChanges,
  detachUnsavedChanges,
} from 'src/modules/browserEvents';
import { getOperationNameFromQuery } from 'src/modules/utils';
import { navigateToUrl } from 'src/utils';

import { logError } from '../../../../modules/error-logger/browserLog';
import { GET_DOCUMENT_DOWNLOAD_LINK } from '../DocumentSelect/get-document-download-link.graphql';

import translations from './.vocab';

interface Props {
  id: string;
  resumeId: string;
}

export const DocumentDownloadButton = ({ id, resumeId }: Props) => {
  const { t } = useTranslations(translations);
  const trackingClient = useTrackingClient();
  const client = useApolloClient();
  const resumeDownloadLinkTrack = () => {
    client
      .query({
        query: GET_DOCUMENT_DOWNLOAD_LINK,
        variables: {
          resumeId,
        },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        const downloadLink = res.data?.viewer?.documentDownloadLink?.link;
        if (downloadLink) {
          trackingClient.trackLink({
            link: 'resume_download_pressed',
            currentPage: Page.DOCUMENT_PAGE,
            pageTitle: Page.DOCUMENT_PAGE,
            isExitLink: false,
          });
          detachUnsavedChanges();
          navigateToUrl(downloadLink);
          attachUnsavedChanges();
        }
      })
      .catch((err) => {
        logError(
          { ...err, type: 'resume-download-link' },
          {
            error: err,
            operationName: getOperationNameFromQuery(
              GET_DOCUMENT_DOWNLOAD_LINK,
            ),
          },
        );
      });
  };

  return (
    <ButtonIcon
      id={id}
      label={t('Download')}
      icon={<IconDownload />}
      onClick={resumeDownloadLinkTrack}
    />
  );
};
